import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Notfound from "../views/404.vue";
import Sms from "../views/Sms.vue";
import Elev from "../views/Elev.vue";
import Elever from "../views/Elever.vue";
import Logud from "../views/Logud.vue";
import MinProfil from "../views/MinProfil.vue";
import Profil from "../views/Profil.vue";
import ProfilNy from "../views/ProfilNy.vue";
import Test from "../views/Test.vue";
import Hold from "../views/Hold.vue";
import HoldDetails from "../views/HoldDetails.vue";
import Employees from "../views/Employees.vue";
import ClassOverview from "../views/ClassOverview.vue";
import Attendance from "../views/Attendance.vue";
import Inactive from "../views/Inactive.vue";
import Admin from "../views/Admin.vue";
import Planlagte from "../views/Planlagte.vue";
import SendteSms from "../views/SendteSms.vue";

import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { title: "Login" },
  },
  {
    path: "/logud",
    name: "logud",
    component: Logud,
  },

  {
    path: "/minprofil",
    name: "minprofil",
    component: MinProfil,
    meta: { requiresAuth: true, title: "Min profil" },
  },

  {
    path: "/test",
    name: "test",
    component: Test,
    meta: { requiresAuth: true, title: "Test" },
  },

  {
    path: "/ansatte",
    name: "ansatte",
    component: Employees,
    meta: { requiresAuth: true, title: "Ansatte" },
  },

  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: { requiresAuth: true, title: "Administration" },
  },
  {
    path: "/hold",
    name: "hold",
    component: Hold,
    meta: { requiresAuth: true, title: "Hold" },
  },

  {
    path: "/hold/:id",
    name: "holddetails",
    component: HoldDetails,
    meta: {
      requiresAuth: true,
      title: "Hold",
    },
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /user/:id is matched
      { path: "", component: ClassOverview },
      { path: "sms", component: Sms },
      { path: "sms/planlagte", component: Planlagte },
      { path: "sms/sendte", component: SendteSms },
      { path: "inaktive", component: Inactive },
      { path: "fremmoede", component: Attendance },
    ],
  },
  {
    path: "/profil/ny",
    name: "profilny",
    component: ProfilNy,
    meta: { requiresAuth: true, title: "Ny profil" },
  },

  {
    path: "/profil/:id",
    name: "profil",
    component: Profil,
    meta: { requiresAuth: true, title: "Profil" },
  },
  {
    path: "/sms",
    name: "sms",
    component: Sms,
    meta: { requiresAuth: true, title: "SMS" },
  },
  {
    path: "/elever",
    name: "elever",
    component: Elever,
    meta: { requiresAuth: true, title: "Elever" },
  },

  {
    path: "/elev/:id",
    name: "elev",
    component: Elev,
    meta: { requiresAuth: true },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  { path: "*", name: "NotFound", component: Notfound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAuthenticated = firebase.auth().currentUser;

  if (to.meta.title) {
    document.title = "Kompetencehuset | " + to.meta.title;
  } else {
    document.title = "Kompetencehuset Administration";
  }
  // console.log("isauthenticated", isAuthenticated);
  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;
